import React, { useEffect, useState } from 'react';

import {
  Box, IconButton, Dialog, DialogActions, DialogContent,
  DialogTitle, Button, CircularProgress, TextField, Grid, Divider, Chip,
  Switch, FormControlLabel
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import PageHeader1 from '../../components/common/PageHeader1';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PoojaConfig() {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editForm, setEditForm] = useState({ key: '', title: '', isActive: false });
  const [actionLoading, setActionLoading] = useState({});

  const fetchConfigs = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("astroVani-admin-token");
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/pooja/Config`, {
        headers: { Authorization: token }
      });
      const result = await response.json();
      if (response.ok) {
        const data = result?.data || result || [];
        setConfigs(Array.isArray(data) ? data : []);
      } else {
        toast.error('Failed to fetch configs');
      }
    } catch (error) {
      toast.error('Failed to fetch configs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const handleOpenEdit = (row) => {
    setEditForm({ key: row.key, title: row.title || '', isActive: row.isActive || false });
    setIsEditing(true);
    setEditOpen(true);
  };

  const handleOpenCreate = () => {
    setEditForm({ key: '', title: '', isActive: false });
    setIsEditing(false);
    setEditOpen(true);
  };

  const handleEditSubmit = async () => {
    if (!editForm.key.trim()) { toast.error('Key is required'); return; }
    if (editForm.key !== 'isRandomPoojaAstrologers' && (!editForm.title || !editForm.title.trim())) { toast.error('Title is required'); return; }

    setEditLoading(true);
    try {
      const token = localStorage.getItem("astroVani-admin-token");
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/pooja/Config`, {
        method: 'PATCH',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(editForm)
      });
      
      if (response.ok) {
        toast.success('Config saved successfully!');
        setEditOpen(false);
        fetchConfigs();
      } else {
        toast.error('Failed to save config');
      }
    } catch (err) {
      toast.error('Failed to save config');
    } finally {
      setEditLoading(false);
    }
  };

  const handleToggleStatus = async (key, currentStatus) => {
    setActionLoading(prev => ({ ...prev, [`toggle-${key}`]: true }));
    try {
      const token = localStorage.getItem("astroVani-admin-token");
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/pooja/Config`, {
        method: 'PATCH',
        headers: { 'Authorization': token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, isActive: !currentStatus })
      });
      if (response.ok) {
        toast.success('Status updated successfully');
        fetchConfigs();
      } else {
        toast.error('Failed to update status');
      }
    } catch (err) {
      toast.error('Failed to update status');
    } finally {
      setActionLoading(prev => ({ ...prev, [`toggle-${key}`]: false }));
    }
  };

  const columns = [
    { field: 'sno', headerName: 'S.No', width: 70, align: 'center', headerAlign: 'center' },
    {
      field: 'actions', headerName: 'Actions', width: 100, sortable: false, filterable: false, headerAlign: 'center', align: 'center',
      renderCell: ({ row }) => (
        <IconButton size="small" onClick={() => handleOpenEdit(row)} sx={{ color: '#1976d2' }}>
          <i className="icofont-edit" style={{ fontSize: '17px' }}></i>
        </IconButton>
      ),
    },
    { field: 'key', headerName: 'Config Key', width: 250 },
    { field: 'title', headerName: 'Title', width: 350 },
    {
      field: 'isActive', headerName: 'Status', width: 120, headerAlign: 'center', align: 'center',
      renderCell: ({ row }) => {
        if (row.key === 'isRandomPoojaAstrologers') {
          return (
            <Switch
              size="small"
              checked={row.isActive}
              onChange={() => handleToggleStatus(row.key, row.isActive)}
              disabled={actionLoading[`toggle-${row.key}`]}
            />
          );
        }
        return (
          <Chip label={row.isActive ? 'Active' : 'Inactive'} size="small"
            color={row.isActive ? 'success' : 'default'} sx={{ fontWeight: 600 }} />
        );
      },
    },
  ];

  const rows = configs.map((item, index) => ({
    sno: index + 1,
    id: item._id || item.key || index,
    key: item.key || '',
    title: item.title || '',
    isActive: item.isActive,
  }));

  return (
    <div className="body d-flex">
      <div className="container-xxl">
        <PageHeader1 pagetitle="Pooja Config" />

        
        {/* <div className="card mb-3" style={{ borderRadius: '12px', padding: '20px' }}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleOpenCreate} size="small" sx={{ textTransform: 'none' }}>
              + Add Config
            </Button>
          </Box>
        </div> */}

        <div className="card mt-3" style={{ borderRadius: '12px', overflow: 'hidden' }}>
          <div className="card-body" style={{ padding: 0 }}>
            <DataGrid loading={loading} columns={columns} rows={rows} autoHeight disableRowSelectionOnClick />
          </div>
        </div>
      </div>

      <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <i className="icofont-settings" style={{ color: '#1976d2' }}></i> Edit Config
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 2.5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" label="Key *" value={editForm.key}
                disabled={isEditing}
                onChange={(e) => setEditForm({ ...editForm, key: e.target.value })} />
            </Grid>
            {editForm.key !== 'isRandomPoojaAstrologers' && (
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="Title *" value={editForm.title}
                  onChange={(e) => setEditForm({ ...editForm, title: e.target.value })} />
              </Grid>
            )}
            {editForm.key === 'isRandomPoojaAstrologers' && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={editForm.isActive}
                      onChange={(e) => setEditForm({ ...editForm, isActive: e.target.checked })}
                      color="primary"
                    />
                  }
                  label="Is Active"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setEditOpen(false)} variant="outlined" disabled={editLoading}>Cancel</Button>
          <Button onClick={handleEditSubmit} variant="contained" color="primary" disabled={editLoading}>
            {editLoading ? <CircularProgress size={20} color="inherit" /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PoojaConfig;
